module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 031.9b4f44e2.jpg";